<template>
  <div class="bg-white dark:bg-slate-800 p-4 rounded-md mt-5">
    <woot-loading-state
      v-if="uiFlags"
      class="text-xs"
      :message="$t('REPORT.LOADING_CHART')"
    />
    <div v-else>
      <div
        class="text-xl font-bold text-slate-500 dark:text-slate-100 mt-3 mb-5 ml-4"
      >
        {{ $t('WORK_ORDER_REPORTS.PROCESSED') }}
      </div>
      <div v-if="tableData.length > 0" class="mx-4">
        <ve-table
          max-height="calc(100vh - 21.875rem)"
          :fixed-header="true"
          :columns="columns"
          :table-data="tableData"
        />
      </div>
      <div v-else class="flex justify-center items-center my-10">
        {{ $t('WORK_ORDER_REPORTS.NO_DATA') }}
      </div>
    </div>
  </div>
</template>

<script>
import { VeTable } from 'vue-easytable';

export default {
  components: {
    VeTable,
  },
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    uiFlags: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      columns: [
        {
          field: 'number',
          key: 'number',
          title: this.$t('WORK_ORDER_REPORTS.TABLE.NUMBER'),
          align: 'center',
          width: 50,
        },
        {
          field: 'work_order_master_name',
          key: 'work_order_master_name',
          title: this.$t('WORK_ORDER_REPORTS.TABLE.NAME'),
          align: 'left',
          width: 200,
        },
        {
          field: 'work_order_type_name',
          key: 'work_order_type_name',
          title: this.$t('WORK_ORDER_REPORTS.TABLE.TYPE'),
          align: 'left',
          width: 200,
        },
        {
          field: 'total_wo',
          key: 'total_wo',
          title: this.$t('WORK_ORDER_REPORTS.TABLE.TOTAL'),
          align: 'center',
          width: 100,
        },
      ],
    };
  },
};
</script>
